export const ProviderData = () => {
    return process.env.REACT_APP_CONTEXT === 'develop'
        ? process.env.REACT_APP_DATA_LOCAL
        : document.getElementById('root')?.getAttribute('data-filter') ?? process.env.REACT_APP_DATA_REMOTE
}

export const KMLData = () => {
    return process.env.REACT_APP_CONTEXT === 'develop'
        ? process.env.REACT_APP_KML_LOCAL
        : process.env.REACT_APP_KML_REMOTE
}
